// removed by extract-text-webpack-plugin
module.exports = {"seoHeading":"_1XN-b","seoSubHeading":"_3wTzo"};